import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Screens } from '~/constants/config/permissions';
import { ConfigurationSettingsLayout } from '~/features/configuration/components/configuration-settings-layout';
import { requirePermission } from '~/utils/guards';

/**
 * Search schema for /configuration and its children. Platform lives in the URL
 * so selecting a different platform survives refresh + bookmarks and so the
 * Configuration Manager tabs share the same selection. Treatment + Dashboard
 * Configuration also inherit this param to scope their X-Platform-ID calls.
 */
const searchSchema = z.object({
  platform: z.enum(['GMC', 'META', 'TIKTOK']).catch('GMC').default('GMC'),
});

/**
 * Access policy: super admins and tenant admins (`TENANT_ADMIN_ROLES`)
 * always pass; any other role needs explicit `configuration` screen access
 * or `configuration:read` resource permission. Non-matching users fall back
 * to `/` which then routes via the connection gate.
 *
 * The component mounts `ConfigurationSettingsLayout` — the inline-sidebar
 * skeleton that matches Platform Administration and Subsidiary Settings, so
 * every multi-page tenant control surface shares the same shape.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration')({
  validateSearch: searchSchema,
  beforeLoad: requirePermission(Screens.CONFIGURATION),
  component: ConfigurationSettingsLayout,
});
